<div class="rs-modal-close">
  <button (click)="close()" class="rs-link-action rs-link-action-close">
    <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
      ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
    >
  </button>
</div>
<div class="rs-modal-heading">
  <span *ngIf="!isActiveOption()">
    {{ 'ebu.ordering.confirmation.modal.order' | translate }}
  </span>
  <span *ngIf="isActiveOption()">
    {{ 'ebu.ordering.confirmation.modal.cease' | translate }}
  </span>
  <h2 class="rs-modal-heading-title">
    <span *ngIf="canDoOrderAction">{{ getOptionName() }}</span>
  </h2>
</div>
<div class="rs-modal-content">
  <p>{{ orderingInput?.validation?.description }}</p>
  <p>{{ orderingInput?.validation?.question }}</p>
</div>
<div class="rs-modal-footer">
  <div class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only">
    <div class="rs-flex-columns rs-order-m1">
      <p class="small-only-text-center">
        <a
          href="javacript:void(0)"
          (click)="cancel()"
          role="button"
          data-modal-close=""
          data-tms-button-name="cancel"
          data-tms-action-name="close"
        >
          {{ 'ebu.ordering.confirmation.cancel.button.label' | translate }}
        </a>
      </p>
    </div>
    <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
      <button class="rs-btn rs-btn-order" (click)="confirmOrder()">
        <span>
          {{ 'ebu.ordering.confirmation.confirm.button.label' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
